/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, memo } from 'react';
import { Button, Modal, Table } from 'semantic-ui-react';
import { autoEditEmptyReason } from './CompositionDocumentBundleFunctions';
import { loadSourceJsonFunction } from './loadSourceJsonFunction';
import { getStringFromFHIR, DisplayFromFHIR } from './ResourceFunctions';
import {
  sectionCodeResults, emptyTextNoData
} from './CodeSystemLookup';
import { EditTableCellEvidenceOnlyModal } from './EditTableCellModal';
import scrollTo from './ScrollTo';
import { addToEvidenceDisplayDictionary } from './CompositionEvidenceTableViewingTool';
import { DataEntry } from './DataEntryFormFunctions';

const getIdFromReference = (reference) => {
  let id = undefined;
  if (reference && typeof reference === "object") {
    id = reference.reference?.replace("#", "") || reference.identifier?.value || reference.display;
    if (id.split("/").length === 2) {
      id = id.split("/")[1];
    }
  }
  return id;
}

const AddTableRowModal = ({ resourceDictionaryState, setOpenAddTableRowModalState,
  setArrayState, reportType }) => {
  let noGroups = false;
  const groupReferencesDictionary = resourceDictionaryState.groupReferencesDictionary;
  const groupKeys = Object.keys(groupReferencesDictionary);
  if (!groupKeys || groupKeys.length === 0) {
    noGroups = true;
  }

  const [addTableRowModalState, setAddTableRowModalState] = useState({
    "newRowTitle": "",
    "newRowFocus": ""
  });
  const [groupsState, setGroupsState] = useState({ "groups": [] });
  const [groupKeysState, setGroupKeysState] = useState([]);
  const [groupReferencesDictionaryState, setGroupReferencesDictionaryState] = useState({});

  const submitNewRowChange = () => {
    if (addTableRowModalState.newRowTitle && addTableRowModalState.newRowFocus) {
      let entryArray = [];
      for (let entryKey of Object.keys(addTableRowModalState)) {
        if (entryKey !== "newRowTitle" && entryKey !== "newRowFocus") {
          entryArray.push(JSON.parse(JSON.stringify(addTableRowModalState[entryKey])));
        }
      }
      setArrayState(prevState => {
        let newRow = {
          "title": addTableRowModalState.newRowTitle,
          "code": sectionCodeResults,
          "focus": addTableRowModalState.newRowFocus || { "display": "[No data]" },
          "entry": entryArray
        }
        return { ...prevState, "newRow": newRow };
      });
      setOpenAddTableRowModalState(prevState => { return { ...prevState, openModal: false }; });
      alert("Update the Resource to view and edit your added row."); //This kind of thing should trigger the alert modal instead
    }
  }

  useEffect(() => {
    if (groupsState.groups.length > 0) {
      let newGroupKeys = [];
      let newGroupReferencesDictionary = {};
      for (let group of groupsState.groups) {
        let groupId = getIdFromReference(group);
        newGroupKeys.push(groupId);
        newGroupReferencesDictionary[groupId] = group;
      }
      setGroupKeysState(newGroupKeys);
      setGroupReferencesDictionaryState(newGroupReferencesDictionary);
    }
  }, [groupsState])

  let modalContent = <div style={{
    paddingTop: "6px", paddingLeft: "20px", paddingRight: "20px",
    paddingBottom: "40px", width: "100%", height: "100%", overflow: "auto"
  }}>
    <Button style={{ padding: "6px", position: "absolute", right: "14px" }}
      className="formButton negative"
      content="✖"
      onClick={() => {
        setOpenAddTableRowModalState(prevState => { return { ...prevState, openModal: false }; });
      }} />
    <h3>Name the Outcome (how it will show in the table row header)</h3>
    <br />
    <DataEntry datatype='string' elementName='newRowTitle' fieldLabel='Title' required
      startingValue={addTableRowModalState.newRowTitle} setResourceState={setAddTableRowModalState} />
    <br />
    <h3>Set or create the structured Outcome Definition</h3>
    <br />
    {reportType === "Participant Flow" ?
      <DataEntry datatype='Reference' elementName='newRowFocus' enableCreation={true}
        fieldLabel='ParticipantFlowEvidenceVariable (Resource Reference)' referencedResourceTypes={['EvidenceVariable']}
        startingResourceType="EvidenceVariable" setProfile="ParticipantFlowEvidenceVariable"
        startingValue={addTableRowModalState.newRowFocus} setResourceState={setAddTableRowModalState} />
      :
      <DataEntry datatype='Reference' elementName='newRowFocus' enableCreation={true}
        fieldLabel='OutcomeDefinition (Resource Reference)' referencedResourceTypes={['EvidenceVariable']}
        startingResourceType="EvidenceVariable" setProfile="VariableDefinition"
        startingValue={addTableRowModalState.newRowFocus} setResourceState={setAddTableRowModalState} />
    }
    {groupKeys.map((groupKey, groupIndex) => {
      return <div key={groupIndex}>
        <br />
        <h3>Set or create the structured Evidence for {groupReferencesDictionary[groupKey].display}</h3>
        <br />
        <DataEntry datatype='Reference' elementName={groupKey} enableCreation={true}
          fieldLabel='Evidence (Resource Reference)' referencedResourceTypes={['Evidence']}
          startingResourceType="Evidence"
          setProfile={groupReferencesDictionary[groupKey].type === "EvidenceVariable" ? "ComparativeEvidence" : "NonComparativeEvidence"}
          addElementValues={groupReferencesDictionary[groupKey].type === "EvidenceVariable" ?
            {
              variableDefinition: [
                {
                  "description": "Parent Population",
                  "variableRole": "population",
                  "observed": { "display": "Parent Population" }
                },
                {
                  "description": groupReferencesDictionary[groupKey]?.display,
                  "variableRole": "exposure",
                  "observed": groupReferencesDictionary[groupKey]
                },
                {
                  "description": addTableRowModalState.newRowFocus?.display,
                  "variableRole": "outcome",
                  "observed": addTableRowModalState.newRowFocus
                }
              ]
            }
            :
            {
              variableDefinition: [
                {
                  "description": groupReferencesDictionary[groupKey]?.display,
                  "variableRole": "population",
                  "observed": groupReferencesDictionary[groupKey]
                },
                {
                  "description": addTableRowModalState.newRowFocus?.display,
                  "variableRole": "outcome",
                  "observed": addTableRowModalState.newRowFocus
                }
              ]
            }
          }
          startingValue={addTableRowModalState[groupKey]} setResourceState={setAddTableRowModalState} />
      </div>
    })}
    <br /><br /><span>
      <Button style={{ color: "#FFFFFF", width: "230px", float: "left" }} className="formButton"
        content="Submit Changes" positive
        onClick={submitNewRowChange}
        disabled={!addTableRowModalState.newRowTitle || !addTableRowModalState.newRowFocus}
      />
      &nbsp;&nbsp;
      {!addTableRowModalState.newRowTitle && <>Enter a title at the top to submit changes.</>}
      {!addTableRowModalState.newRowFocus && <> Enter a focus (EvidenceVariable reference) at the top to submit changes.</>}
    </span>
    <br />
  </div>;

  if (noGroups) {
    modalContent = <div style={{
      paddingTop: "6px", paddingLeft: "20px", paddingRight: "20px",
      paddingBottom: "40px", width: "100%", height: "100%", overflow: "auto"
    }}>
      <Button style={{ padding: "6px", position: "absolute", right: "14px" }}
        className="formButton negative"
        content="✖"
        onClick={() => {
          setOpenAddTableRowModalState(prevState => { return { ...prevState, openModal: false }; });
        }} />
      <h3>Name the Outcome (how it will show in the table row header)</h3>
      <br />
      <DataEntry datatype='string' elementName='newRowTitle' fieldLabel='Title' required
        startingValue={addTableRowModalState.newRowTitle} setResourceState={setAddTableRowModalState} />
      <br />
      <h3>Set or create the structured Outcome Definition</h3>
      <br />
      {reportType === "Participant Flow" ?
        <DataEntry datatype='Reference' elementName='newRowFocus' enableCreation={true}
          fieldLabel='ParticipantFlowEvidenceVariable (Resource Reference)' referencedResourceTypes={['EvidenceVariable']}
          startingResourceType="EvidenceVariable" setProfile="ParticipantFlowEvidenceVariable"
          startingValue={addTableRowModalState.newRowFocus} setResourceState={setAddTableRowModalState} />
        :
        <DataEntry datatype='Reference' elementName='newRowFocus' enableCreation={true}
          fieldLabel='OutcomeDefinition (Resource Reference)' referencedResourceTypes={['EvidenceVariable']}
          startingResourceType="EvidenceVariable" setProfile="VariableDefinition"
          startingValue={addTableRowModalState.newRowFocus} setResourceState={setAddTableRowModalState} />
      }
      <h3>Set or create the structured Group Resources</h3>
      <br />
      <DataEntry asArray={true} datatype='Reference' elementName='groups' enableCreation={true}
        fieldLabel='Group (Resource Reference)' referencedResourceTypes={['Group']}
        startingResourceType="Group"
        startingValue={groupsState.groups} setResourceState={setGroupsState} />
      {groupKeysState.map((groupKey, groupIndex) => {
        return <div key={groupIndex}>
          <br />
          <h3>Set or create the structured Evidence for {groupReferencesDictionaryState[groupKey].display}</h3>
          <br />
          <DataEntry datatype='Reference' elementName={groupKey} enableCreation={true}
            fieldLabel='Evidence (Resource Reference)' referencedResourceTypes={['Evidence']}
            startingResourceType="Evidence"
            setProfile={groupReferencesDictionaryState[groupKey].type === "EvidenceVariable" ? "ComparativeEvidence" : "NonComparativeEvidence"}
            addElementValues={groupReferencesDictionaryState[groupKey].type === "EvidenceVariable" ?
              {
                variableDefinition: [
                  {
                    "description": "Parent Population",
                    "variableRole": "population",
                    "observed": { "display": "Parent Population" }
                  },
                  {
                    "description": groupReferencesDictionaryState[groupKey]?.display,
                    "variableRole": "exposure",
                    "observed": groupReferencesDictionaryState[groupKey]
                  },
                  {
                    "description": addTableRowModalState.newRowFocus?.display,
                    "variableRole": "outcome",
                    "observed": addTableRowModalState.newRowFocus
                  }
                ]
              }
              :
              {
                variableDefinition: [
                  {
                    "description": groupReferencesDictionaryState[groupKey]?.display,
                    "variableRole": "population",
                    "observed": groupReferencesDictionaryState[groupKey]
                  },
                  {
                    "description": addTableRowModalState.newRowFocus?.display,
                    "variableRole": "outcome",
                    "observed": addTableRowModalState.newRowFocus
                  }
                ]
              }
            }
            startingValue={addTableRowModalState[groupKey]} setResourceState={setAddTableRowModalState} />
        </div>
      })}

      <br /><br /><span>
        <Button style={{ color: "#FFFFFF", width: "230px", float: "left" }} className="formButton"
          content="Submit Changes" positive
          onClick={submitNewRowChange}
          disabled={!addTableRowModalState.newRowTitle || !addTableRowModalState.newRowFocus}
        />
        &nbsp;&nbsp;
        {!addTableRowModalState.newRowTitle && <>Enter a title at the top to submit changes.</>}
        {!addTableRowModalState.newRowFocus && <> Enter a focus (EvidenceVariable reference) at the top to submit changes.</>}
      </span>
      <br />
    </div>;
  }

  return (
    <Modal
      style={{ padding: "0px", margin: "0px" }}
      dimmer={<Modal.Dimmer style={{ backgroundColor: "#00000077" }} />}
      open={true}
      centered={false}
      content={modalContent}
    />
  )
}

const generateEvidenceTextDiv = (newEvidenceJson) => {
  let textDiv = "";
  if (newEvidenceJson) {
    let description = "";
    let statistic = "";
    if (newEvidenceJson.statistic && newEvidenceJson.statistic[0]) {
      if (newEvidenceJson.statistic[0].statisticType && newEvidenceJson.statistic[0].quantity) {
        let statisticTypeDisplay = newEvidenceJson.statistic[0].statisticType.coding?.[0]?.display || newEvidenceJson.statistic[0].statisticType.text || getStringFromFHIR.CodeableConcept(newEvidenceJson.statistic[0].statisticType);
        statistic = statisticTypeDisplay + " " + getStringFromFHIR.Quantity(newEvidenceJson.statistic[0].quantity);
      } else if (newEvidenceJson.statistic[0].description) {
        statistic = newEvidenceJson.statistic[0].description;
      }
    }
    if (statistic) {
      if (newEvidenceJson.statistic[0].attributeEstimate?.[0]?.type) {
        let attributeEstimate = newEvidenceJson.statistic[0].attributeEstimate[0];
        let attribute = "";
        if (attributeEstimate.level) {
          attribute = (attributeEstimate.level * 100).toString() + "% ";
        }
        attribute += attributeEstimate.type.coding?.[0]?.display || attributeEstimate.type.text || getStringFromFHIR.CodeableConcept(attributeEstimate.type);
        if (attributeEstimate.quantity) {
          attribute += " " + getStringFromFHIR.Quantity(attributeEstimate.quantity);
        }
        if (attributeEstimate.range) {
          attribute += " " + getStringFromFHIR.Range(attributeEstimate.range);
        }
        statistic += " (" + attribute + ")";
      }
      description = statistic;
    }
    if (!description) {
      description = newEvidenceJson.description || "";
    }
    let narrative = description;
    if (narrative) {
      textDiv = "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + narrative + "</p></div>";
    }
  }
  return textDiv;
}

const EvidenceReferenceDataEntry = memo(({ startingValue, outcomeGroup, setEntryArrayState,
  globalContext, statisticType, statisticUnit, knownDataCount, resourceDictionaryState,
  setSourceJsonState, outcomeName, outcomeFocus }) => {

  let compositionId = resourceDictionaryState.compositionId;
  let compositionTitle = resourceDictionaryState.compositionTitle;
  let combinedDictionary = resourceDictionaryState.combinedDictionary;
  let evidenceDisplayDictionary = resourceDictionaryState.evidenceDisplayDictionary;
  let suggestedEvidenceTitle = "Evidence for " + outcomeName + " in " + outcomeGroup.display;
  let variableDefinition = [{
    "variableRole": "population",
    "observed": outcomeGroup
  }, {
    "variableRole": "outcome",
    "observed": outcomeFocus
  }];
  let evidenceSummaryDiv = generateEvidenceTextDiv(combinedDictionary?.[startingValue?.entry?.[0]?.reference?.split("/")[1]]);
  let entryAddElementValues = {
    title: combinedDictionary?.[startingValue?.entry?.[0]?.reference?.split("/")[1]]?.title || suggestedEvidenceTitle,
    relatesTo: [
      {
        "type": "part-of",
        "targetReference": {
          "reference": "Composition/" + compositionId,
          "type": "Composition",
          "display": compositionTitle
        }
      }
    ],
    description: combinedDictionary?.[startingValue?.entry?.[0]?.reference?.split("/")[1]]?.description || "",
    variableDefinition: variableDefinition,
    statistic: combinedDictionary?.[startingValue?.entry?.[0]?.reference?.split("/")[1]]?.statistic || ""
  };

  let startingEntryInstance = {
    reference: "", type: "Evidence", identifier: "", display: ""
  }
  if (!startingValue) {
    startingValue = "";
  } else {
    if (startingValue.extension) { startingEntryInstance.extension = startingValue.extension; }
    if (startingValue.reference) { startingEntryInstance.reference = startingValue.reference; }
    if (startingValue.type) { startingEntryInstance.type = startingValue.type; }
    if (startingValue.identifier) { startingEntryInstance.identifier = startingValue.identifier; }
    if (startingValue.display) { startingEntryInstance.display = startingValue.display; }
  }

  const [openEditModalState, setOpenEditModalState] = useState({ "openModal": false });
  const [entryInstanceState, setEntryInstanceState] = useState(JSON.parse(JSON.stringify(startingEntryInstance || {})));

  useEffect((() => {
    if (Object.keys(entryInstanceState).length > 0) {
      let newReference = {};
      if (entryInstanceState.extension) { newReference.extension = entryInstanceState.extension; }
      if (entryInstanceState.reference) { newReference.reference = entryInstanceState.reference; }
      if (entryInstanceState.type) { newReference.type = entryInstanceState.type; }
      if (entryInstanceState.identifier) { newReference.identifier = entryInstanceState.identifier; }
      if (entryInstanceState.display) { newReference.display = entryInstanceState.display; }
      if (Object.keys(newReference).length === 0 || 
      (Object.keys(newReference).length === 1 && newReference.type === "Evidence")) {
        newReference = null;
      }
      setEntryArrayState(prevState => {
        return { ...prevState, [getIdFromReference(outcomeGroup)]: newReference }
      });
    }
  }), [entryInstanceState]);

  if (!openEditModalState.openModal) {
    return <div>
      {startingValue && <div style={{ marginLeft: "24px" }}>
        {evidenceSummaryDiv &&
          <div><b>Summary: </b><DisplayFromFHIR xhtml={evidenceSummaryDiv} /></div>}
        <br />
        {(getIdFromReference(entryInstanceState) &&
          evidenceDisplayDictionary[getIdFromReference(entryInstanceState)]) &&
          <div><b>Summary: </b>{evidenceDisplayDictionary[getIdFromReference(entryInstanceState)]}</div>
        }
        <br />
        <DisplayFromFHIR reference={startingValue} />
        <br />
      </div>}
      &nbsp;&nbsp;
      <span className={"unselectable"} style={{ cursor: "pointer" }}
        onClick={() => {
          setOpenEditModalState({ openModal: true });
        }}>
        {startingValue ? <>✎ Edit</> : <>➕ Add</>}
      </span>
    </div>
  } else {
    return <EditTableCellEvidenceOnlyModal entryInstance={entryInstanceState}
      setEntryInstanceState={setEntryInstanceState} addElementValues={entryAddElementValues}
      setOpenEditModalState={setOpenEditModalState} globalContext={globalContext}
      statisticType={statisticType} statisticUnit={statisticUnit}
      knownDataCount={knownDataCount}
      setSourceJsonState={setSourceJsonState}
      resourceDictionaryState={resourceDictionaryState} />
  }
});

const generateEvidenceNarrative = (newEvidenceJson) => {

  if (newEvidenceJson) {
    let description = "";
    let statistic = "";
    if (newEvidenceJson.statistic?.length === 1) {
      if (newEvidenceJson.statistic[0].statisticType && newEvidenceJson.statistic[0].quantity) {
        let statisticTypeDisplay = newEvidenceJson.statistic[0].statisticType.coding?.[0]?.display || newEvidenceJson.statistic[0].statisticType.text || getStringFromFHIR.CodeableConcept(newEvidenceJson.statistic[0].statisticType);
        statistic = statisticTypeDisplay + " " + getStringFromFHIR.Quantity(newEvidenceJson.statistic[0].quantity);
      } else if (newEvidenceJson.statistic[0].description) {
        statistic = newEvidenceJson.statistic[0].description;
      }
      if (newEvidenceJson.statistic[0].attributeEstimate?.[0]?.type) {
        let attributeEstimate = newEvidenceJson.statistic[0].attributeEstimate[0];
        let attribute = "";
        if (attributeEstimate.level) {
          attribute = (attributeEstimate.level * 100).toString() + "% ";
        }
        attribute += attributeEstimate.type.coding?.[0]?.display || attributeEstimate.type.text || getStringFromFHIR.CodeableConcept(attributeEstimate.type);
        if (attributeEstimate.quantity) {
          attribute += " " + getStringFromFHIR.Quantity(attributeEstimate.quantity);
        }
        if (attributeEstimate.range) {
          attribute += " " + getStringFromFHIR.Range(attributeEstimate.range);
        }
        statistic += " (" + attribute + ")";
      }
    }
    if (newEvidenceJson.statistic?.length > 1) {
      for (const stat of newEvidenceJson.statistic) {
        let statisticInstance = "";
        if (stat.category) {
          statisticInstance = stat.category + ": ";
        }
        if (stat.statisticType && stat.quantity) {
          let statisticTypeDisplay = stat.statisticType.coding?.[0]?.display || stat.statisticType.text || getStringFromFHIR.CodeableConcept(stat.statisticType);
          statisticInstance += statisticTypeDisplay + " " + getStringFromFHIR.Quantity(stat.quantity);
        } else if (stat.description) {
          statisticInstance += stat.description;
        }
        if (stat.attributeEstimate?.[0]?.type) {
          let attributeEstimate = statisticInstance.attributeEstimate[0];
          let attribute = "";
          if (attributeEstimate.level) {
            attribute = (attributeEstimate.level * 100).toString() + "% ";
          }
          attribute += attributeEstimate.type.coding?.[0]?.display || attributeEstimate.type.text || getStringFromFHIR.CodeableConcept(attributeEstimate.type);
          if (attributeEstimate.quantity) {
            attribute += " " + getStringFromFHIR.Quantity(attributeEstimate.quantity);
          }
          if (attributeEstimate.range) {
            attribute += " " + getStringFromFHIR.Range(attributeEstimate.range);
          }
          statisticInstance += " (" + attribute + ")";
        }
        if (statistic) {
          statistic += "; " + statisticInstance;
        } else {
          statistic = statisticInstance;
        }
      }
    }
    if (statistic) {
      description = statistic;
    }
    if (!description) {
      description = newEvidenceJson.description || "";
    }
    let narrative = description;
    let newText = JSON.parse(JSON.stringify(emptyTextNoData));
    if (narrative) {
      let divContainedNarrative = "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + narrative + "</p></div>";
      newText = { status: "generated", div: divContainedNarrative };
    }
    return newText;
  }
  return { status: "empty", div: "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>[No data.]</p></div>" };
}

const TableRowSectionDataEntry = memo(({ startingValue, setTableRowSectionState,
  setSourceJsonState, sampleSizeDefaultState, globalContext,
  resourceDictionaryState }) => {

  let outcomeName = startingValue?.title || startingValue?.focus?.display;
  let combinedDictionary = resourceDictionaryState.combinedDictionary;
  let groupReferencesDictionary = resourceDictionaryState.groupReferencesDictionary;
  let groupKeys = Object.keys(groupReferencesDictionary);

  const [entryArrayState, setEntryArrayState] = useState(null);
  const [startingEntryArrayState, setStartingEntryArrayState] = useState(null);
  const [statisticDefaultsState, setStatisticDefaultsState] = useState({
    "statisticType": "", "units": ""
  });
  const [selectedStatisticDefaultsState, setSelectedStatisticDefaultsState] = useState({
    "statisticType": "", "units": ""
  });

  useEffect(() => {
    let startingEntryStateValues = {};
    let defaultStatisticType = "";
    let defaultStatisticUnits = "";
    if (startingValue?.entry?.length) {
      for (let itemIndex in startingValue.entry) {
        let evidenceReference = startingValue.entry[itemIndex];
        let evidenceId = getIdFromReference(evidenceReference);
        let item = combinedDictionary[evidenceId];
        let entryJson;
        if (item?.resourceType === "Evidence") {
          if (item.meta?.profile?.[0] === "http://hl7.org/fhir/uv/ebm/StructureDefinition/comparative-evidence" &&
            item.variableDefinition?.[1]?.variableRole === "exposure") {
            entryJson = item.variableDefinition[1].observed || item.variableDefinition[1].intended;
          } else if (item.variableDefinition?.[0]?.variableRole === "population") {
            entryJson = item.variableDefinition[0].observed || item.variableDefinition[0].intended;
          }
        }
        if (entryJson) {
          let entryId = getIdFromReference(entryJson);
          startingEntryStateValues[entryId] = evidenceReference;
        }
        if (!defaultStatisticType && resourceDictionaryState?.combinedDictionary &&
          resourceDictionaryState.combinedDictionary[evidenceId]) {
          let evidenceJson = resourceDictionaryState.combinedDictionary[evidenceId];
          if (evidenceJson.statistic?.[0]?.statisticType) {
            defaultStatisticType = evidenceJson.statistic[0].statisticType;
            if (!defaultStatisticUnits && evidenceJson.statistic?.[0]?.quantity?.unit) {
              defaultStatisticUnits = evidenceJson.statistic[0].quantity.unit;
            }
          }
        }
      }
    }
    setEntryArrayState(JSON.parse(JSON.stringify(startingEntryStateValues)));
    setStartingEntryArrayState(JSON.parse(JSON.stringify(startingEntryStateValues)));
    setStatisticDefaultsState({
      "statisticType": defaultStatisticType, "units": defaultStatisticUnits
    });
  }, [])

  useEffect(() => {
    if (entryArrayState && JSON.stringify(entryArrayState) !== JSON.stringify(startingEntryArrayState)) {
      let newEntryArray = [];
      for (const key in entryArrayState) {
        if (entryArrayState[key]) {
        newEntryArray.push(entryArrayState[key]);
        }
      }
      if (newEntryArray?.length) {
        setTableRowSectionState(prevState => { return { ...prevState, "entry": newEntryArray } });
      }
    }
  }, [entryArrayState]);

  return <>
    <Table.Cell style={{ verticalAlign: "top" }}>
      {startingValue.title || startingValue.focus?.display}
      <p><span className={"unselectable"} style={{ cursor: "pointer" }}
        onClick={() => {
          setSelectedStatisticDefaultsState({
            "statisticType": statisticDefaultsState.statisticType || "",
            "units": statisticDefaultsState.units || ""
          })
        }}>
        {(statisticDefaultsState.statisticType && !selectedStatisticDefaultsState.statisticType) &&
          <>➕ Add Default Statistic Type {getStringFromFHIR.CodeableConcept(statisticDefaultsState.statisticType)} and Units {statisticDefaultsState.units || "none"}</>}
      </span></p>
    </Table.Cell>
    {entryArrayState && groupKeys.map((groupKey, groupIndex) => {
        return <Table.Cell key={groupIndex} style={{ verticalAlign: "top" }}>
          <span>
            <EvidenceReferenceDataEntry startingValue={entryArrayState[groupKey]}
              outcomeName={outcomeName} outcomeFocus={startingValue.focus}
              outcomeGroup={groupReferencesDictionary[groupKey]} setEntryArrayState={setEntryArrayState}
              statisticType={selectedStatisticDefaultsState.statisticType}
              statisticUnit={selectedStatisticDefaultsState.units}
              knownDataCount={sampleSizeDefaultState[groupKey]}
              resourceDictionaryState={resourceDictionaryState}
              globalContext={globalContext} setSourceJsonState={setSourceJsonState} />
          </span>
        </Table.Cell>
    })}
  </>
});

const TableRowEdit = memo(({ startingValue, setArrayState, sectionArrayIndex,
  setSourceJsonState, sampleSizeDefaultState,
  globalContext, resourceDictionaryState }) => {
  let startingSection = {
    title: "", code: sectionCodeResults,
    author: [], focus: "", text: "", orderedBy: "", entry: [], emptyReason: "", section: []
  }
  if (startingValue) {
    if (startingValue.extension) { startingSection.extension = startingValue.extension; }
    if (startingValue.title) { startingSection.title = startingValue.title; }
    if (startingValue.code) { startingSection.code = startingValue.code; }
    if (startingValue.author) { startingSection.author = startingValue.author; }
    if (startingValue.focus) { startingSection.focus = startingValue.focus; }
    if (startingValue.text) { startingSection.text = startingValue.text; }
    if (startingValue.orderedBy) { startingSection.orderedBy = startingValue.orderedBy; }
    if (startingValue.entry) { startingSection.entry = startingValue.entry; }
    if (startingValue.emptyReason) { startingSection.emptyReason = startingValue.emptyReason; }
    if (startingValue.section) { startingSection.section = startingValue.section; }
  }

  const [tableRowSectionState, setTableRowSectionState] = useState(JSON.parse(JSON.stringify(startingSection || {})));

  useEffect((() => {
    if (Object.keys(tableRowSectionState).length > 0) {
      let newSection = {};
      if (tableRowSectionState.extension) { newSection.extension = tableRowSectionState.extension; }
      if (tableRowSectionState.title) { newSection.title = tableRowSectionState.title; }
      if (tableRowSectionState.code) { newSection.code = tableRowSectionState.code; }
      if (Array.isArray(tableRowSectionState.author) && tableRowSectionState.author.length > 0) {
        newSection.author = tableRowSectionState.author;
      }
      if (tableRowSectionState.focus) { newSection.focus = tableRowSectionState.focus; }
      if (tableRowSectionState.text) { newSection.text = tableRowSectionState.text; }
      if (tableRowSectionState.orderedBy) { newSection.orderedBy = tableRowSectionState.orderedBy; }
      if (Array.isArray(tableRowSectionState.entry) && tableRowSectionState.entry.length > 0) {
        newSection.entry = tableRowSectionState.entry;
      }
      if (tableRowSectionState.emptyReason) { newSection.emptyReason = tableRowSectionState.emptyReason; }
      if (Array.isArray(tableRowSectionState.section) && tableRowSectionState.section.length > 0) {
        newSection.section = tableRowSectionState.section;
      }
      newSection = autoEditEmptyReason(newSection);
      if (Object.keys(newSection).length === 0 || (Object.keys(newSection).length === 1 && newSection.code)) {
        newSection = null;
      }
      newSection = JSON.parse(JSON.stringify(newSection));
      if (sectionArrayIndex || sectionArrayIndex === 0 || sectionArrayIndex === "0") {
        setArrayState(prevState => {
          return { ...prevState, [sectionArrayIndex]: newSection };
        });
      }
    }
  }), [tableRowSectionState]);

  return <TableRowSectionDataEntry startingValue={startingSection}
    setTableRowSectionState={setTableRowSectionState}
    sampleSizeDefaultState={sampleSizeDefaultState}
    globalContext={globalContext} setSourceJsonState={setSourceJsonState}
    resourceDictionaryState={resourceDictionaryState} />
});

const EvidenceTableEdit = ({ resultsSectionsState, setResultsSectionsState, setSourceJsonState,
  globalContext, resourceDictionaryState, reportType }) => {

  const groupReferencesDictionary = resourceDictionaryState.groupReferencesDictionary;
  const groupKeys = Object.keys(groupReferencesDictionary);
  const outcomeGroupsQuantityDictionary = resourceDictionaryState.outcomeGroupsQuantityDictionary;

  const [sampleSizeDefaultState, setSampleSizeDefaultState] = useState({});
  const [openAddTableRowModalState, setOpenAddTableRowModalState] = useState({ "openModal": false });

  return <>{resultsSectionsState && <>
    {openAddTableRowModalState.openModal &&
      <AddTableRowModal resourceDictionaryState={resourceDictionaryState}
        setOpenAddTableRowModalState={setOpenAddTableRowModalState}
        setArrayState={setResultsSectionsState} reportType={reportType} />}
    <Table>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Variable Name</Table.HeaderCell>
          {groupKeys.map((groupKey, groupIndex) => {
            return <Table.HeaderCell key={groupIndex}>
              {groupReferencesDictionary[groupKey].display}
            </Table.HeaderCell>
          })}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {(outcomeGroupsQuantityDictionary && Object.keys(outcomeGroupsQuantityDictionary).length > 0) &&
          <Table.Row key={"topline"}>
            <Table.Cell style={{ verticalAlign: "top" }}></Table.Cell>
            {groupKeys.map((groupKey, groupIndex) => {
              return <Table.Cell key={groupIndex} style={{ verticalAlign: "top" }}>
                {(outcomeGroupsQuantityDictionary[groupKey] || outcomeGroupsQuantityDictionary[groupKey] === 0) && <p>
                  <span className={"unselectable"} style={{ cursor: "pointer" }}
                    onClick={() => {
                      setSampleSizeDefaultState(prevState => {
                        return {
                          ...prevState, [groupKey]: outcomeGroupsQuantityDictionary[groupKey],
                          [groupIndex]: true
                        }
                      })
                    }}>
                    {(!sampleSizeDefaultState[groupIndex]) &&
                      <>➕ Add {outcomeGroupsQuantityDictionary[groupKey]} as Sample Size</>}
                  </span>
                </p>}
              </Table.Cell>
            })}
          </Table.Row>}
        {(resultsSectionsState && Object.keys(resultsSectionsState).length > 0) &&
          Object.entries(resultsSectionsState).sort().map((keyValuePair) => {
            return <Table.Row key={keyValuePair[0]}>
              <TableRowEdit startingValue={keyValuePair[1]}
                setArrayState={setResultsSectionsState} sectionArrayIndex={keyValuePair[0]}
                sampleSizeDefaultState={sampleSizeDefaultState}
                globalContext={globalContext} setSourceJsonState={setSourceJsonState}
                resourceDictionaryState={resourceDictionaryState} />
            </Table.Row>
          })}
      </Table.Body>
    </Table>
    <Button style={{ color: "#FFFFFF", width: "230px", float: "left" }} className="formButton"
      content="+ Add Table Row" positive
      onClick={() => {
        setOpenAddTableRowModalState({ openModal: true });
      }}
    />
    <br />   <br />
  </>}
  </>
};

const loadResourceDictionary = (resourceState, sourceJsonState, setResourceDictionaryState, setResultsSectionsState, setAdditionalSectionsState) => {

  let resourceDictionary = sourceJsonState.nonrecursiveResourceDictionary;
  let resultsSectionsKeys = [];
  let resultsSectionsDictionary = {};
  let additionalSections = {};
  let groupReferencesDictionary = {};
  let baselineDenomCountsSection;
  let containedDictionary = sourceJsonState.containedDictionary;
  let evidenceDisplayDictionary = {};
  let combinedDictionary = sourceJsonState.combinedDictionary;
  let outcomeGroupsQuantityDictionary = {};
  let compositionId = resourceState.id;
  let compositionTitle = resourceState.title || resourceState.name;
  if (Array.isArray(resourceState.section) && resourceState.section.length > 0) {
    let tempSection = JSON.parse(JSON.stringify(resourceState.section));
    for (const sectionIndex in tempSection) {
      const section = tempSection[sectionIndex];
      const sectionPath = [sectionIndex];
      const sectionPathString = sectionPath.join(",");
      if (section?.code?.coding?.[0]?.code === "results") {
        resultsSectionsKeys.push(sectionPathString);
        resultsSectionsDictionary[sectionPathString] = section;
      } else if (section?.code?.text === "BaselineDenom") {
        baselineDenomCountsSection = section;
      } else if (section?.code?.text === "OutcomeGroupList" || section?.code?.text === "BaselineGroupList" ||
        section?.code?.text === "FlowGroupList" || section?.code?.text === "GroupList") {
        if (section.entry?.length) {
          for (let entry of section.entry) {
            let entryId = getIdFromReference(entry);
            if (!groupReferencesDictionary[entryId]) {
              groupReferencesDictionary[entryId] = entry;
            }
          }
        }
      } else {
        if (section?.section?.length > 0) {
          let additionalSubsections = [];
          let sectionFocus = section.focus;
          for (const subsectionIndex in section.section) {
            const subsection = section.section[subsectionIndex];
            const subsectionPath = sectionPath.concat([subsectionIndex]);
            const subsectionPathString = subsectionPath.join(",");
            if (subsection?.code?.coding?.[0]?.code === "results") {
              if (!subsection.focus && sectionFocus) {
                subsection.focus = sectionFocus;
              }
              resultsSectionsKeys.push(subsectionPathString);
              resultsSectionsDictionary[subsectionPathString] = subsection;
            } else if (subsection?.code?.text === "OutcomeGroupList" || subsection?.code?.text === "BaselineGroupList" ||
              subsection?.code?.text === "FlowGroupList" || subsection?.code?.text === "GroupList") {
              if (subsection.entry?.length) {
                for (let entry of subsection.entry) {
                  let entryId = getIdFromReference(entry);
                  if (!groupReferencesDictionary[entryId]) {
                    groupReferencesDictionary[entryId] = entry;
                  }
                }
              }
            } else {
              if (subsection.focus) {
                sectionFocus = subsection.focus;
              }
              if (subsection?.section?.length > 0) {
                let additionalSubSubsections = [];
                for (const subsubsectionIndex in subsection.section) {
                  const subsubsection = subsection.section[subsubsectionIndex];
                  const subsubsectionPath = subsectionPath.concat([subsubsectionIndex]);
                  const subsubsectionPathString = subsubsectionPath.join(",");
                  if (subsubsection?.code?.coding?.[0]?.code === "results") {
                    if (!subsubsection.focus && sectionFocus) {
                      subsubsection.focus = sectionFocus;
                    }
                    resultsSectionsKeys.push(subsubsectionPathString);
                    resultsSectionsDictionary[subsubsectionPathString] = subsubsection;
                  } else {
                    additionalSubSubsections.push(subsubsection);
                  }
                }
                if (additionalSubSubsections.length > 0) {
                  subsection.section = additionalSubSubsections
                } else {
                  delete subsection.section;
                }
              }
              if (subsection?.section?.length || subsection?.entry ||
                (subsection?.text && subsection.text.div && subsection.text.status !== "empty")) {
                additionalSubsections.push(subsection);
              }
            }
          }
          if (additionalSubsections.length > 0) {
            section.section = additionalSubsections;
          } else {
            delete section.section;
          }
        }
        if (section?.section?.length || section?.entry ||
          (section?.text && section.text.div && section.text.status !== "empty") ||
          section?.title === "Discussion Section") {
          additionalSections[sectionPathString] = section;
        }
      }
    }
  }
  if (containedDictionary && Object.keys(containedDictionary).length) {
    for (const key of Object.keys(containedDictionary)) {
      const item = containedDictionary[key];
      if (item.resourceType === "Evidence") {
        addToEvidenceDisplayDictionary(item, evidenceDisplayDictionary);
        if (item.meta?.profile?.[0] === "http://hl7.org/fhir/uv/ebm/StructureDefinition/comparative-evidence" &&
          item.variableDefinition?.[1]?.variableRole === "exposure") {
          let entry = item.variableDefinition[1].observed || item.variableDefinition[1].intended;
          let entryId = getIdFromReference(entry);
          if (!groupReferencesDictionary[entryId]) {
            groupReferencesDictionary[entryId] = entry;
          }
        } else if (item.variableDefinition?.[0]?.variableRole === "population") {
          let entry = item.variableDefinition[0].observed || item.variableDefinition[0].intended;
          let entryId = getIdFromReference(entry);
          if (!groupReferencesDictionary[entryId]) {
            groupReferencesDictionary[entryId] = entry;
          }
        }
      }
    }
  }
  if (resourceDictionary && Object.keys(resourceDictionary).length) {
    for (const key of Object.keys(resourceDictionary)) {
      const item = resourceDictionary[key];
      if (item.resourceType === "Evidence") {
        addToEvidenceDisplayDictionary(item, evidenceDisplayDictionary);
        if (item.meta?.profile?.[0] === "http://hl7.org/fhir/uv/ebm/StructureDefinition/comparative-evidence" &&
          item.variableDefinition?.[1]?.variableRole === "exposure") {
          let entry = item.variableDefinition[1].observed || item.variableDefinition[1].intended;
          let entryId = getIdFromReference(entry);
          if (!groupReferencesDictionary[entryId]) {
            groupReferencesDictionary[entryId] = entry;
          }
        } else if (item.variableDefinition?.[0]?.variableRole === "population") {
          let entry = item.variableDefinition[0].observed || item.variableDefinition[0].intended;
          let entryId = getIdFromReference(entry);
          if (!groupReferencesDictionary[entryId]) {
            groupReferencesDictionary[entryId] = entry;
          }
        }
      }
    }
  }

  const groupKeys = Object.keys(groupReferencesDictionary);
  for (let groupId of groupKeys) {
    if (groupId.split("/").length === 2) {
      groupId = groupId.split("/")[1];
    }
    if (combinedDictionary[groupId]?.quantity || combinedDictionary[groupId]?.quantity === 0) {
      outcomeGroupsQuantityDictionary[groupId] = combinedDictionary[groupId].quantity;
    }
  }
  setResultsSectionsState(resultsSectionsDictionary);
  setAdditionalSectionsState(additionalSections);
  setResourceDictionaryState({
    "loaded": true,
    "resourceDictionary": resourceDictionary,
    "containedDictionary": containedDictionary,
    "combinedDictionary": combinedDictionary,
    "evidenceDisplayDictionary": evidenceDisplayDictionary,
    "resultsSectionsKeys": resultsSectionsKeys,
    "resultsSectionsDictionary": resultsSectionsDictionary,
    "additionalSectionsDictionary": additionalSections,
    "groupReferencesDictionary": groupReferencesDictionary,
    "baselineDenomCountsSection": baselineDenomCountsSection,
    "outcomeGroupsQuantityDictionary": outcomeGroupsQuantityDictionary,
    "compositionId": compositionId,
    "compositionTitle": compositionTitle,
    "fullResourceState": resourceState
  });
}

const CompositionTableReportAuthor = ({ resourceState, setResourceState, globalContext, sourceJsonState,
  setSourceJsonState, profile }) => {

  let reportType;
  if (profile === "OutcomeMeasureReport") {
    reportType = "Outcome Measure"
  } else if (profile === "BaselineMeasureReport") {
    reportType = "Baseline Measure"
  } else if (profile === "ParticipantFlowReport") {
    reportType = "Participant Flow"
  }

  const [resourceDictionaryState, setResourceDictionaryState] = useState({});
  const [resultsSectionsState, setResultsSectionsState] = useState({});
  const [additionalSectionsState, setAdditionalSectionsState] = useState({});
  const [addedSectionState, setAddedSectionState] = useState({ "title": "" });

  const loadSourceJson = () => {
    if (!sourceJsonState.loaded && resourceState?.section?.length) {
      loadSourceJsonFunction(resourceState, globalContext, setSourceJsonState);
    } else if (sourceJsonState?.scrollTo) {
      scrollTo("resourceTextViewSegment", sourceJsonState.scrollTo, true);
    }
  }

  useEffect(() => {
    loadSourceJson();
    if (sourceJsonState.loaded) {
      loadResourceDictionary(resourceState, sourceJsonState, setResourceDictionaryState, setResultsSectionsState, setAdditionalSectionsState);
    }
  }, [sourceJsonState]);

  useEffect(() => {
    if (addedSectionState.addSection && addedSectionState.title) {
      let sectionToBeAdded = { "title": addedSectionState.title };
      setAdditionalSectionsState(prevState => {
        let sectionPathString = Object.keys(prevState).length.toString();
        return { ...prevState, [sectionPathString]: sectionToBeAdded };
      });
      setResourceState(prevState => {
        let newSection = prevState.section;
        newSection.push(sectionToBeAdded);
        return { ...prevState, "section": newSection };
      })
      setAddedSectionState({ "title": "" });
    }
  }, [addedSectionState]);

  useEffect(() => {
    if (sourceJsonState?.loaded && resourceDictionaryState?.loaded) {
      setResourceState(prevState => {
        let newSection = prevState.section;
        let addedSectionPathString = [newSection.length].join(",");
        for (const key of Object.keys(resultsSectionsState)) {
          let newResultsSection = resultsSectionsState[key];
          if (key === "newRow") {
            newSection[addedSectionPathString] = newResultsSection;
            setResultsSectionsState(prevState => {
              let newResultsSections = prevState;
              newResultsSections[addedSectionPathString] = newResultsSection;
              delete newResultsSections.newRow;
              return newResultsSections;
            })
          } else {
            let sectionPath = key.split(",");
            if (sectionPath.length === 1) {
              if (key !== addedSectionPathString) {
                let sectionIndex = parseInt(sectionPath[0]);
                newSection[sectionIndex] = newResultsSection;
              }
            } else if (sectionPath.length === 2) {
              let sectionIndexA = parseInt(sectionPath[0]);
              let sectionIndexB = parseInt(sectionPath[1]);
              newSection[sectionIndexA].section[sectionIndexB] = newResultsSection;
            } else if (sectionPath.length === 3) {
              let sectionIndexA = parseInt(sectionPath[0]);
              let sectionIndexB = parseInt(sectionPath[1]);
              let sectionIndexC = parseInt(sectionPath[2]);
              newSection[sectionIndexA].section[sectionIndexB].section[sectionIndexC] = newResultsSection;
            }
          }
        }
        return { ...prevState, "section": newSection };
      })
    }
  }, [resultsSectionsState]);

  return <>{(sourceJsonState.loaded && (resourceDictionaryState?.resultsSectionsKeys?.length > 0 ||
    (additionalSectionsState && Object.keys(additionalSectionsState).length > 0)
  )) ?
    <div style={{ marginTop: "12px" }}>
      <div>
        <h3 id="groups">Groups</h3>
        <div style={{ marginLeft: "24px" }}>
          {resourceDictionaryState.groupReferencesDictionary &&
            Object.keys(resourceDictionaryState.groupReferencesDictionary).map((groupKey, groupIndex) => {
              return <div key={groupIndex}>
                <DisplayFromFHIR reference={resourceDictionaryState.groupReferencesDictionary[groupKey]} />
              </div>
            })}
        </div>
        {reportType === "Baseline Measure" && <h3 id="baseline-measures">Baseline Measures</h3>}
        {reportType === "Participant Flow" && <h3 id="participant-flow-measures">Participant Flow Measures</h3>}
        {reportType === "Outcome Measure" && <h3 id="outcome-measures">Outcome Measures</h3>}
        <div style={{ marginLeft: "24px" }}>
          {resourceDictionaryState.resultsSectionsKeys.map((sectionKey) => {
            return <div key={sectionKey}><DisplayFromFHIR reference={resourceDictionaryState.resultsSectionsDictionary[sectionKey].focus} /></div>
          })}
        </div>
        <h3 id="evidence">Evidence</h3>
        <div style={{ marginLeft: "24px" }}>
          <EvidenceTableEdit resultsSectionsState={resultsSectionsState}
            setSourceJsonState={setSourceJsonState}
            setResultsSectionsState={setResultsSectionsState} globalContext={globalContext}
            resourceDictionaryState={resourceDictionaryState}
            reportType={reportType} />
        </div>
        <h3 id="discussion">Discussion</h3>
        <div style={{ marginLeft: "24px" }}>
          <p>Use Section Detail tab to edit section content.</p>
          {(additionalSectionsState && Object.keys(additionalSectionsState).length > 0) &&
            <div>
              <p>Top-level sections include:</p>
              <div style={{ marginLeft: "24px" }}>
                {Object.keys(additionalSectionsState).map((key, subsectionIndex) => {
                  let subsection = additionalSectionsState[key]
                  let sectionName = subsection.title || subsection.code?.text ||
                    subsection.code?.coding?.[0]?.display || subsection.code?.coding?.[0]?.code;
                  return <span key={subsectionIndex}>
                    <p><b>Section: </b>{sectionName}</p>
                  </span>;
                })}
              </div>
            </div>}
          <div>
            <p>Enter a title then click Add Section.</p>
            <DataEntry datatype='string' elementName='title' fieldLabel='Title'
              startingValue={addedSectionState.title}
              setResourceState={setAddedSectionState} />
            <Button className="formButton" style={{ color: "#000000", width: "100%" }}
              content={"Add Section"}
              onClick={() => {
                setAddedSectionState(prevState => { return { ...prevState, addSection: true }; });
              }}
              disabled={!addedSectionState.title} />
          </div>
        </div>
      </div>
    </div>
    :
    <div>
      <p>Loading ...</p>
    </div>}</>
};

export { CompositionTableReportAuthor, generateEvidenceNarrative, getIdFromReference };